// Product display name (white-label). Set VITE_PRODUCT_NAME at build time.
export const PRODUCT_NAME: string = (import.meta.env.VITE_PRODUCT_NAME as string) || 'Polestead';

// Support contact for the screens that cannot use the in-app reporter — chiefly
// the root crash boundary, which catches failures ABOVE the reporter provider
// and therefore has no capture buffer to attach. Same default as TPRM7's
// apps/admin/src/lib/brand.ts: one inbox across both products.
export const SUPPORT_EMAIL: string =
  (import.meta.env.VITE_SUPPORT_EMAIL as string) || 'support@polestead.com';
